import { render, staticRenderFns } from "./VirtualTransfer.vue?vue&type=template&id=245f08e2&scoped=true&"
import script from "./VirtualTransfer.vue?vue&type=script&lang=js&"
export * from "./VirtualTransfer.vue?vue&type=script&lang=js&"
import style0 from "./VirtualTransfer.vue?vue&type=style&index=0&id=245f08e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f08e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245f08e2')) {
      api.createRecord('245f08e2', component.options)
    } else {
      api.reload('245f08e2', component.options)
    }
    module.hot.accept("./VirtualTransfer.vue?vue&type=template&id=245f08e2&scoped=true&", function () {
      api.rerender('245f08e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/VirtualTransfer.vue"
export default component.exports